export const GET_TEAMS = "getTeams";
export const HAS_MORE = "hasMore";
export const FETCHING = "fetching";
export const INITIALLY_LOADED = "initiallyLoaded";
export const GET_ERROR = "getError";
export const IS_EMPTY = "isEmpty";
